import React from "react";
import { ABOUT_PAGE } from "../../data/constants";

const Intro = () => {
  return (
    <div className="bg-[#F5F7FA] pt-[30px] pb-[64px] md:py-[120px] px-6 md:px-20">
      <div className="flex flex-col md:flex-row justify-between gap-10">
        {/* Left Heading */}
        <div className="md:w-1/2">
          <h2 className="font-utility font-medium text-[30px] md:text-[54px] leading-[120%] tracking-[-0.01em] capitalize text-[#011621] !-mt-2">
            {ABOUT_PAGE.intro.heading.split("\n").map((line, i) => (
              <React.Fragment key={i}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </h2>
        </div>

        {/* Right Paragraph */}
        <div className="md:w-1/2">
          <p className="font-inter font-normal text-[18px] md:text-[20px] leading-[150%] tracking-[-0.005em] text-[#033652]">
            {ABOUT_PAGE.intro.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Intro;
